module.exports = __webpack_public_path__ + "static/media/Medalha-Bronze.676c6982.svg";